/*
  Clarity custom events and stable ids for the shop (see snippets/clarity.liquid).
  Plain ES5: must run in old Android WebView / Facebook & Instagram in-app browsers.
  Never put personal data (names, emails, order numbers) into event names or tags.
*/
(function () {
  'use strict';

  function track(name) {
    if (typeof window.clarity === 'function') window.clarity('event', name);
  }

  // add_to_cart: every successful /cart/add request, reported by assets/cart-events.js.
  document.addEventListener('nooria:cart-added', function () {
    track('add_to_cart');
  });

  // begin_checkout: any checkout button, link or express checkout button.
  var CHECKOUT_SELECTOR = [
    '[data-track="checkout"]',
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href*="/checkout"]',
    '.shopify-payment-button__button',
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart'
  ].join(',');
  var checkoutTracked = false;

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if ((el.matches || el.msMatchesSelector || el.webkitMatchesSelector).call(el, selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    if (checkoutTracked || !closest(e.target, CHECKOUT_SELECTOR)) return;
    checkoutTracked = true;
    track('begin_checkout');
  }, true);

  document.addEventListener('submit', function (e) {
    var action = (e.target && e.target.getAttribute('action')) || '';
    if (checkoutTracked || action.indexOf('/checkout') === -1) return;
    checkoutTracked = true;
    track('begin_checkout');
  }, true);

  // Cookie banner (TinyCookie app): the app renders its buttons without ids, so give
  // them stable ones for Clarity smart events. Selectors come from the app's markup
  // and don't depend on the button text or language.
  var COOKIE_IDS = [
    ['.tinycookie-main-buttons > .tinycookie-accept-all', 'cookie-accept'],
    ['.tinycookie-main-buttons > .tinycookie-button:not(.tinycookie-accept-all)', 'cookie-reject'],
    ['.tinycookie-preferences-accept', 'cookie-preferences-accept'],
    ['.tinycookie-preferences-required', 'cookie-preferences-reject']
  ];

  function tagCookieButtons() {
    for (var i = 0; i < COOKIE_IDS.length; i++) {
      var el;
      try { el = document.querySelector(COOKIE_IDS[i][0]); } catch (err) { el = null; }
      if (el && !el.id) {
        el.id = COOKIE_IDS[i][1];
        el.setAttribute('data-track', COOKIE_IDS[i][1]);
      }
    }
    // "Customise" is the only .tinycookie-button outside the main button row.
    var buttons = document.querySelectorAll('.tinycookie-button');
    for (var j = 0; j < buttons.length; j++) {
      var parent = buttons[j].parentElement;
      if (!buttons[j].id && !(parent && parent.classList.contains('tinycookie-main-buttons'))) {
        buttons[j].id = 'cookie-customise';
        buttons[j].setAttribute('data-track', 'cookie-customise');
      }
    }
  }

  var tagScheduled = false;
  function scheduleTag() {
    if (tagScheduled) return;
    tagScheduled = true;
    setTimeout(function () {
      tagScheduled = false;
      tagCookieButtons();
    }, 100);
  }

  tagCookieButtons();
  if (window.MutationObserver && document.body) {
    new MutationObserver(scheduleTag).observe(document.body, { childList: true, subtree: true });
  }

  // Consent choice as events too, so accept/reject rates are filterable in Clarity.
  // Taken from the clicks, not visitorConsentCollected: the banner also fires that
  // event on page load with the default (rejected) state.
  var COOKIE_EVENTS = {
    'cookie-accept': 'cookie_accept_all',
    'cookie-reject': 'cookie_reject_all',
    'cookie-preferences-accept': 'cookie_accept_all',
    'cookie-preferences-reject': 'cookie_reject_all'
  };
  document.addEventListener('click', function (e) {
    var el = closest(e.target, '[data-track^="cookie-"]');
    var name = el && COOKIE_EVENTS[el.getAttribute('data-track')];
    if (name) track(name);
  }, true);
})();
